export default "__VITE_PUBLIC_ASSET__7bdde376__"